import React, { useEffect } from "react";
import { Box, MenuItem, Select, Typography, styled } from "@mui/material";
import { useProductQuery, useModuleQuery } from "../../useQuery";
import { useSelector, useDispatch } from "react-redux";
import {
  updatePreProcessingProduct,
  updatePreProcessingModule,
  updatePostProcessingProduct,
  updatePostProcessingModule,
} from "../../Redux/ProcessingSettings/ProcessingSettings";

const StyledSelect = styled(Select)`
  border-radius: 5px;
  border: 1px solid #d1dbff;
  font-size: 16px;
  color: #2b3539;
  min-width: 180px;
  max-height: 300px;
  background-color: #ffffff;
  .MuiSelect-select {
    padding: 13px 15px;
  }
`;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: "300px",
    },
  },
};

const StyledLabel = styled(Typography)`
  color: #8089a8;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 4px;
`;

const ModuleSelector = ({
  onModuleChange,
  initialValue = null,
  tabId = "pre",
}) => {
  const dispatch = useDispatch();

  const processingConfig = useSelector((state) =>
    tabId === "pre"
      ? state.processingSettings.preProcessing
      : state.processingSettings.postProcessing
  );

  const { product, module } = processingConfig;

  // Initialize from initialValue
  const hasInitialized = React.useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;

    if (initialValue) {
      if (initialValue.idproducts) {
        dispatch(
          tabId === "pre"
            ? updatePreProcessingProduct(initialValue.idproducts.toString())
            : updatePostProcessingProduct(initialValue.idproducts.toString())
        );
      }

      if (initialValue.idmodules) {
        dispatch(
          tabId === "pre"
            ? updatePreProcessingModule(initialValue.idmodules.toString())
            : updatePostProcessingModule(initialValue.idmodules.toString())
        );
      }
    }

    hasInitialized.current = true;
  }, [initialValue, tabId, dispatch]);

  const { data: products } = useProductQuery();
  const { data: modules } = useModuleQuery(product, {
    enabled: !!product,
  });

  const handleProductChange = (event) => {
    const newProduct = event.target.value;

    dispatch(
      tabId === "pre"
        ? updatePreProcessingProduct(newProduct)
        : updatePostProcessingProduct(newProduct)
    );

    // When product changes, clear module
    dispatch(
      tabId === "pre"
        ? updatePreProcessingModule("")
        : updatePostProcessingModule("")
    );

    if (onModuleChange) {
      onModuleChange(null);
    }
  };

  const handleModuleChange = (event) => {
    const newModule = event.target.value;

    dispatch(
      tabId === "pre"
        ? updatePreProcessingModule(newModule)
        : updatePostProcessingModule(newModule)
    );

    if (onModuleChange) {
      onModuleChange({
        idproducts: product,
        idmodules: newModule,
      });
    }
  };

  return (
    <Box display="flex" gap={2} alignItems="flex-start">
      <Box flex={1}>
        <StyledLabel>Application</StyledLabel>
        <StyledSelect
          MenuProps={MenuProps}
          value={product || ""}
          onChange={handleProductChange}
          displayEmpty
          fullWidth
        >
          <MenuItem disabled value="">
            Application
          </MenuItem>
          {products?.map((prod) => (
            <MenuItem key={prod.idproducts} value={prod.idproducts}>
              {prod.productname}
            </MenuItem>
          ))}
        </StyledSelect>
      </Box>

      <Box flex={1}>
        <StyledLabel>Module</StyledLabel>
        <StyledSelect
          MenuProps={MenuProps}
          value={module || ""}
          displayEmpty
          onChange={handleModuleChange}
          disabled={!product}
          fullWidth
        >
          <MenuItem disabled value="">
            Module
          </MenuItem>
          {modules?.map((mod) => (
            <MenuItem key={mod.idmodules} value={mod.idmodules}>
              {mod.modulename}
            </MenuItem>
          ))}
        </StyledSelect>
      </Box>
    </Box>
  );
};

export default ModuleSelector;